module.exports = __webpack_public_path__ + "ath_game_web/img/5.5.c8466455.png";